enum ColumnType {
    STRING,
    INTEGER,
    NUMBER,
    PRICE,
    CURRENCY,
    CURRENCYPRICE,
    DATE,
    ENUM,
    DAY_ENUM,
}

export default ColumnType;
